import { Component } from '@angular/core'
import { CookiesConsentService } from 'src/app/services/cookies-consent.service'
import { CookiesConsentOptionsModalComponent } from './cookies-consent-options-modal/cookies-consent-options-modal.component'
import { NzModalService } from 'ng-zorro-antd/modal'

@Component({
    selector: 'app-cookies-consent',
    templateUrl: './cookies-consent.component.html',
    standalone: false
})
export class CookiesConsentComponent {
  constructor(
    private nzModalService: NzModalService,
    private cookiesConsentService: CookiesConsentService,
  ) {}

  public setResponse(isAccepted: boolean): void {
    this.cookiesConsentService.setCookieConsent(isAccepted)
  }

  public openMoreOptions(): void {
    this.nzModalService.create<CookiesConsentOptionsModalComponent, {}, any>({
      nzContent: CookiesConsentOptionsModalComponent,
      nzStyle: { top: '30px' },
      nzFooter: null,
      nzNoAnimation: true,
    })
  }
}
